import React, { useEffect, useState } from 'react';
import { DataShimmer, Helpfull } from '../common';
import FaqTicketCreate from '../common/FaqTicketCreate';
import { getEditMyBusinessInfo, handleImpressionsTrack } from '../../api';
import FaqFeedback from '../common/FaqFeedback';
import EditBusinessFaq from './EditBusinessFaq';
import style from './EditBusiness.module.scss';
import {
  clickTracker,
  getCookie,
  getProjectId,
  getSourceValue,
  handleRedirection,
  helpfulObjData,
} from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import NoDataView from '../../pages/NoDataView';
import { useAuth } from '../../contexts/auth';

const EditBusinessHome = () => {
  const [loading, setLoading] = useState(true);
  const [editBusinessResp, setEditBusinessResp] = useState({});
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const [showEditLisingPage, setShowEditLisingPage] = useState(true);
  const [showEditLisingPageResp, setShowEditLisingPageResp] = useState('');
  const source = getSourceValue();
  const projectId = getProjectId();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [authState] = useAuth();

  useEffect(() => {
    const handleGetEditMyBusinessData = async () => {
      try {
        setLoading(true);
        const commonParams = {
          key: 'EditBusinessNew',
          source,
          backUrl: encodeURI(window.location.href),
          projectId,
        };
        let paramsData = {};
        if (projectId === 'csportal') {
          paramsData = {
            ...commonParams,
            docId: selectedBusiness?.docid || '',
            parentId: selectedBusiness?.parentid || '',
            mobile: (userDetails && userDetails?.mobile) || '',
            compName: selectedBusiness?.compname ? encodeURIComponent(selectedBusiness?.compname) : '',
            area: selectedBusiness?.areaname ? encodeURIComponent(selectedBusiness?.areaname) : '',
            city: selectedBusiness?.data_city ? encodeURIComponent(selectedBusiness?.data_city) : '',
            sid: getCookie('sid') || '',
            shortUrl: selectedBusiness?.shorturl || '',
          };
        } else {
          paramsData = {
            ...commonParams,
            docId: selectedBusinessGenio?.docId || '',
            parentId: selectedBusinessGenio?.parentId || '',
            mobile: profile?.mobile || '',
            compName: selectedBusinessGenio?.companyName ? encodeURIComponent(selectedBusinessGenio?.companyName) : '',
            area: selectedBusinessGenio?.location ? encodeURIComponent(selectedBusinessGenio?.location) : '',
            city: selectedBusinessGenio?.city ? encodeURIComponent(selectedBusinessGenio?.city) : '',
          };
        }
        const res = await getEditMyBusinessInfo(paramsData, projectId);
        setEditBusinessResp(res || {});
        setLoading(false);
      } catch (err) {
        console.log('ERROR in getEditMyBusinessInfo', err);
      }
      setLoading(false);
    };

    handleGetEditMyBusinessData();
  }, []);

  const handleContractCheckboxSubmit = async (responseVal) => {
    setShowEditLisingPageResp(responseVal);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_editmybusiness_submit`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_manage_profile`;
      const llTrdInside = `faq_managebusinessprofile`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
  };

  const isLawyerCategory = sessionStorage.getItem('isLawyerCategory')
    ? JSON.parse(sessionStorage.getItem('isLawyerCategory'))
    : '';

  const profileScore = editBusinessResp?.profileScore ? Math.round(editBusinessResp?.profileScore) : 0;
  return (
    <>
      {loading ? (
        <DataShimmer loading={loading} id="ecsfaq" />
      ) : (
        <>
          {editBusinessResp?.faqsData ? (
            <>
              <div className="p-20">
                <div className={`${style.ScoreBox}`}>
                  <div className={`${style.Score}`}>
                    <svg height="56" width="56" xmlns="http://www.w3.org/2000/svg">
                      <circle
                        cx="28"
                        cy="28"
                        r="23"
                        strokeWidth="6px"
                        style={{ fill: 'none', stroke: 'rgb(228, 234, 239)' }}
                      />
                      <circle
                        className={`${style.Percent}`}
                        cx="28"
                        cy="28"
                        r="23"
                        fill="none"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="6px"
                        stroke={profileScore === 100 ? '#15e415ff' : '#f87b7b'}
                        pathLength="100"
                        style={{
                          strokeDashoffset: editBusinessResp?.profileScore
                            ? 100 - parseInt(editBusinessResp?.profileScore, 10)
                            : 0,
                        }}
                      />
                      <text
                        x="50%"
                        y="50%"
                        dy=".3em"
                        textAnchor="middle"
                        style={{
                          fontSize: editBusinessResp?.profileScore ? '14px' : '9px',
                          fontWeight: 600,
                          fill: '#111',
                        }}
                      >
                        {editBusinessResp?.profileScore ? `${Math.round(editBusinessResp?.profileScore)}%` : 'No Data'}
                      </text>
                    </svg>
                  </div>
                  <div className={`${style.ScoreText}`} style={{ alignSelf: profileScore === 100 ? 'center' : '' }}>
                    {profileScore === 100 ? (
                      <div className="font12 fw600 color111">Your profile is complete.</div>
                    ) : (
                      <>
                        <div className="font12 fw600 color111">Increase Your Business Profile Score!</div>
                        {!isLawyerCategory && <div className="font12 fw400 color111">Reach out to more customers</div>}
                        {projectId === 'csportal' && (
                          <button
                            onClick={async () => {
                              await clickTracker('increasescore', 'editdata');
                              if (projectId === 'csportal') {
                                const liVal = 'click';
                                const liTrd = `click_increasescore`;
                                const faqTypeVal = '';
                                const othersData = [];
                                const llTrd = `click_editbusiness`;
                                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                              }

                              handleRedirection(source, editBusinessResp?.increaseProfileScoreUrl || '');
                            }}
                            type="button"
                            className={`${style.ScoreButton} bluefill_animate mt-6`}
                          >
                            <span className="font11 fw600 colorFFF">INCREASE SCORE</span>
                            <span className={`${style.RightArrow} csicon ml-10`} />
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {showEditLisingPage ? (
                  <div className={`${style.Profile} mt-20`}>
                    {projectId === 'csportal' && (
                      <>
                        <div className={`${style.ProfileHead}`}>
                          <span className={`${style.MangeProfileIcon} csicon`} />
                          <span className="font16 fw600 color111 pl-12">Manage Business Profile</span>
                        </div>
                        <div className={`${style.ProfileText} font12 fw400 color111 mt-6`}>
                          Update Company Name, Address, Contact, Add Offers and Deals, Categories, Photos & Videos,
                          Business Catalogue and more..
                        </div>
                        <button
                          onClick={async () => {
                            await clickTracker('mngprofile', 'editdata');
                            if (projectId === 'csportal') {
                              const liVal = 'click';
                              const liTrd = `click_manage profile`;
                              const faqTypeVal = '';
                              const othersData = [];
                              const llTrd = `click_editbusiness`;
                              await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                            }

                            handleRedirection(source, editBusinessResp?.manageProfileUrl || '');
                          }}
                          type="button"
                          className={`${style.ProfileButon} bluefill_animate font14 fw600 colorFFF mt-20`}
                        >
                          Manage Profile
                        </button>
                      </>
                    )}
                    <div className={`${style.ProfileContent} ${profile === 'csportal' ? 'mt-30' : 'mt-10'}`}>
                      <div className="font12 fw600 color111">Here’s how you can access Edit Listing Page</div>
                      <ul className={`${style.ProfileList}`}>
                        <li className={`${style.ProfileItem} font12 fw400 color111`}>
                          <span className={`${style.ProfileNumber} fw600 mr-15`}>1</span>
                          <span className={`${style.ProfileText}`}>
                            Go to{' '}
                            <a
                              onClick={async () => {
                                if (projectId === 'csportal') {
                                  await clickTracker('mngprofile_mybusiness', 'editdata');
                                  if (projectId === 'csportal') {
                                    const liVal = 'click';
                                    const liTrd = `click_mybusiness`;
                                    const faqTypeVal = '';
                                    const othersData = [];
                                    const llTrd = `click_manage_profile`;
                                    await handleImpressionsTrack(
                                      liVal,
                                      liTrd,
                                      faqTypeVal,
                                      othersData,
                                      llTrd,
                                      authState,
                                    );
                                  }
                                  handleRedirection(source, editBusinessResp?.manageProfileUrl || '');
                                }
                              }}
                              className="fw500 color007"
                              style={{ cursor: projectId === 'csportal' ? 'pointer' : 'auto' }}
                              aria-label="page_redirection"
                              tabIndex={0}
                              role="button"
                              onKeyDown={() => {}}
                            >
                              “My Business”
                            </a>{' '}
                            from Jd home page
                          </span>
                        </li>
                        <br />
                        <li className={`${style.ProfileItem} font12 fw400 color111`}>
                          <span className={`${style.ProfileNumber} fw600 mr-15`}>2</span>
                          <span className={`${style.ProfileText}`}>Select your relevant business</span>
                        </li>
                        <br />
                        <li className={`${style.ProfileItem} font12 fw400 color111`}>
                          <span className={`${style.ProfileNumber} fw600 mr-15`}>3</span>
                          <span className={`${style.ProfileText}`}>
                            Scroll down and select <span className="fw500">“Business Profile”</span>
                          </span>
                        </li>
                        <br />
                        <li className={`${style.ProfileItem} font12 fw400 color111`}>
                          <span className={`${style.ProfileNumber} fw600 mr-15`}>4</span>
                          <span className={`${style.ProfileText}`}>
                            Select the relevant details you wish to edit and proceed
                          </span>
                        </li>
                      </ul>
                    </div>
                    <FaqFeedback
                      faq={{}}
                      helpful={helpful}
                      setHelpful={setHelpful}
                      setShowData={setShowEditLisingPage}
                      faqsFeedbackData={faqsFeedbackData}
                      setFaqsFeedbackData={setFaqsFeedbackData}
                      id="editListingPage"
                      projectId="csportal"
                    />
                  </div>
                ) : (
                  <>
                    {showEditLisingPageResp ? (
                      <div
                        className={`${style.ProfileResponseBorder} font12 fw400 color777 mt-30 p-14`}
                        style={{ height: 'fit-content', width: '100%' }}
                      >
                        {showEditLisingPageResp}
                      </div>
                    ) : (
                      <>
                        {helpful && helpful[1].isActive && (
                          <div className={`${style.ProfileResponseBorder} mt-30 p-20`}>
                            <FaqTicketCreate
                              issue="DATA CHANGES/VALIDATION REQUEST"
                              subIssue="EDIT LISTING-BUSINESS"
                              vertical="Listing"
                              category="CS"
                              ticketCreator="BUSINESS"
                              setShowData={setShowEditLisingPage}
                              hideAlert
                              hideCrossIcon={false}
                              id="editListingPage"
                              projectId="csportal"
                              handleContractCheckboxSubmit={handleContractCheckboxSubmit}
                              faqObj={{}}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
                <div className="font16 fw600 color111 mt-30">Other FAQs</div>
                <EditBusinessFaq
                  faqsData={editBusinessResp?.faqsData}
                  setShowEditLisingPage={setShowEditLisingPage}
                  setShowEditLisingPageResp={setShowEditLisingPageResp}
                />
              </div>
              <Helpfull redirectkey="edit_my_business" />
            </>
          ) : (
            <NoDataView pageName="Edit My Business" />
          )}
        </>
      )}
    </>
  );
};

export default EditBusinessHome;
